import { useEffect } from 'react';

// Gives every table cell a data-label with its column header so that, on
// phones, rows can show as cards of "Label  value" lines (styles/mobile-fit.css).
// Watches the page, so tables that load later are labelled too.
const text = (el) => (el?.innerText || el?.textContent || '').replace(/\s+/g, ' ').trim();

const labelTable = (table) => {
  if (table.hasAttribute('data-no-cards')) return;
  if (!table.classList.contains('m-cards')) table.classList.add('m-cards');
  const headRow = table.querySelector('thead tr');
  if (!headRow) return;
  const heads = [];
  for (const th of headRow.children) { const span = th.colSpan || 1; for (let i = 0; i < span; i++) heads.push(text(th)); }
  for (const tr of table.querySelectorAll('tbody tr, tfoot tr')) {
    let col = 0;
    for (const td of tr.children) {
      const label = td.colSpan > 1 ? '' : (heads[col] || '');
      if (td.getAttribute('data-label') !== label) td.setAttribute('data-label', label);
      col += td.colSpan || 1;
    }
  }
};

const labelGrid = (box) => {
  const head = box.querySelector('.m-head');
  if (!head) return;
  const heads = [...head.children].map(text);
  for (const row of box.querySelectorAll('.grid-cols-12:not(.m-head)')) {
    [...row.children].forEach((cell, i) => {
      const label = i === 0 ? '' : (heads[i] || '');
      if (cell.getAttribute('data-label') !== label) cell.setAttribute('data-label', label);
    });
  }
};

const MobileTableLabels = () => {
  useEffect(() => {
    let raf = 0;
    const run = () => {
      raf = 0;
      document.querySelectorAll('table').forEach(labelTable);
      document.querySelectorAll('.m-grid-table').forEach(labelGrid);
    };
    const queue = () => { if (!raf) raf = requestAnimationFrame(run); };
    const mo = new MutationObserver(queue);
    mo.observe(document.body, { childList: true, subtree: true });
    queue();
    return () => { mo.disconnect(); if (raf) cancelAnimationFrame(raf); };
  }, []);
  return null;
};

export default MobileTableLabels;
